import { EStarredChatsListActionTypes, IStarredChatsListRequest } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TChatListSetSucceedPayload } from '../chatList';

/**
 * Запрос за списком архивных чатов
 */
export const setStarredChatsListPending = actionGenerator<
  EStarredChatsListActionTypes.SetPending,
  IStarredChatsListRequest
>(EStarredChatsListActionTypes.SetPending);

/**
 * Установить список архивных чатов
 */
export const setStarredChatsListSucceed = actionGenerator<
  EStarredChatsListActionTypes.SetSucceed,
  TChatListSetSucceedPayload
>(EStarredChatsListActionTypes.SetSucceed);

/**
 * Установить ошибку запроса списка архивных чатов
 */
export const setStarredChatsListFailed = actionGenerator<EStarredChatsListActionTypes.SetFailed, void>(
  EStarredChatsListActionTypes.SetFailed,
);
